import React from 'react';

import { FormHelperText, BoxProps } from '@chakra-ui/react';

const FormDescription: React.FC<BoxProps> = (props) => <FormHelperText mt='0' mb='6' color="gray.600" fontSize="sm" whiteSpace="pre-line" {...props} />

export default FormDescription;